import type { ReviewApiError } from '@/services/api/reviewService'

/**
 * The server refused a check-in call (a 4xx), with a reason written for the person
 * reading it. The review service's errors carry the status and the server's detail
 * (ReviewApiError); a server error or a dropped connection has no such reason.
 */
export const isRefusal = (error: unknown): boolean => {
  const status = (error as Partial<ReviewApiError> | null)?.status
  return typeof status === 'number' && status >= 400 && status < 500
}

/** Why the server refused a check-in call, in its own words, or the fallback. */
export function serverReason(error: unknown, fallback: string): string {
  const detail = (error as Partial<ReviewApiError> | null)?.detail
  return isRefusal(error) && typeof detail === 'string' && detail.trim() ? detail : fallback
}

/** A 409: the check-in has moved on (completed, held, cancelled) since the page loaded it. */
export const isConflict = (error: unknown): boolean =>
  (error as Partial<ReviewApiError> | null)?.status === 409
